import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

import { useTranslation } from 'react-i18next';

// style
// import { globalStyle } from '../../../global/style';
import styles from '../style';

import DamLatestLarge from './DamLatestLarge';
import DamLatestMedium from './DamLatestMedium';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const {
    children, value, index,
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function DamLists(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    handleSearchMarker, currentMode, currentArea, userIsLogin, value, setValue
  } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function List() {
    const { datasLargeDam, datasMediumDam } = props;

    return (
      <>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" scrollButtons="auto" aria-label="simple tabs example">
          <Tab label={t('แหล่งน้ำขนาดใหญ่')} id="tab-large-dam" aria-controls="tabpanel-0" className={value === 0 ? classes.active_tab : classes.tab} />
          <Tab label={t('แหล่งน้ำขนาดกลาง')} id="tab-medium-dam" aria-controls="tabpanel-1" className={value === 1 ? classes.active_tab : classes.tab} />
        </Tabs>
        <Divider />
        <TabContainer component="div">
          <TabPanel value={value} index={0}>
            <DamLatestLarge
              datas={datasLargeDam}
              handleSearchMarker={handleSearchMarker}
              currentMode={currentMode}
              currentArea={currentArea}
              userIsLogin={userIsLogin}
            />
          </TabPanel>
        </TabContainer>
        <TabContainer component="div">
          <TabPanel value={value} index={1}>
            <DamLatestMedium
              datas={datasMediumDam}
              handleSearchMarker={handleSearchMarker}
              currentMode={currentMode}
              currentArea={currentArea}
              userIsLogin={userIsLogin}
            />
          </TabPanel>
        </TabContainer>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <List />
    </div>
  );
}

TabPanel.defaultProps = {
  children: '',
};

DamLists.propTypes = {
  datasLargeDam: PropTypes.instanceOf(Array).isRequired,
  datasMediumDam: PropTypes.instanceOf(Array).isRequired,
  handleSearchMarker: PropTypes.func.isRequired,
  currentMode: PropTypes.string.isRequired,
  currentArea: PropTypes.instanceOf(Object).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
};
